export default __webpack_public_path__ + "static/media/ser-bazylia-pomidor.f8e5ba96.webp";